import { render, staticRenderFns } from "./WorkspaceMechanismNodeInspectorContent.vue?vue&type=template&id=372639ca&scoped=true"
import script from "./WorkspaceMechanismNodeInspectorContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceMechanismNodeInspectorContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceMechanismNodeInspectorContent.vue?vue&type=style&index=0&id=372639ca&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372639ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('372639ca')) {
      api.createRecord('372639ca', component.options)
    } else {
      api.reload('372639ca', component.options)
    }
    module.hot.accept("./WorkspaceMechanismNodeInspectorContent.vue?vue&type=template&id=372639ca&scoped=true", function () {
      api.rerender('372639ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceMechanismNodeInspectorContent.vue"
export default component.exports